export const getTaskCommentPrefix = (sk: string): 'TASK' | 'SUBTASK' | 'OPTIMIZATION' | 'MONTHLY TASK' => {
  //   console.log('getTaskCommentPrefix', sk)
  if (!sk) return 'TASK'
  if (sk.startsWith('SUBTASK')) return 'SUBTASK'
  if (sk.startsWith('OPTIMIZATION')) return 'OPTIMIZATION'
  if (sk.startsWith('MONTHLY')) return 'MONTHLY TASK'
  return 'TASK'
}
